var HomepageCarousel = function(){
  var header;
  var headerImg;
  var photos;
  var arrLength;
  var currentPhotoIndex;
  var chosenPhoto;

  var _init = function(){
    header = document.getElementById('leadHeader');
    headerImg = document.getElementById('backgroundContainer');
    photos = _converToArray(header.dataset.backgroundImages);
    arrLength = photos.length;
    currentPhotoIndex = 1;


    setInterval(function(){
      _toggleOpacity();
      
      setTimeout(function(){
        chosenPhoto = photos.find(_getPhoto);
        _changePhoto(chosenPhoto);
        if (currentPhotoIndex === arrLength) {
          currentPhotoIndex = 0;
        }
      },375);
    },5000);
  };

  var _converToArray = function(list){
    var index = 0;
    var arr = [];
    var array = list.split(',');
    array.map(function(imageURL){
      index ++;
      var obj = {
        url: imageURL.replace(' ',''),
        index: index
      };  
      arr.push(obj);
    });
    return arr;
  }

  var _getPhoto = function(photo){
    return photo.index === currentPhotoIndex + 1;
  };

  var _changePhoto = function(photo){
    headerImg.style.backgroundImage = 'url('+photo.url+')';
    currentPhotoIndex = photo.index;
  };

  var _toggleOpacity = function(state){
     headerImg.style.opacity = '0';
     setTimeout(function(){
      headerImg.style.opacity = '1';
     }, 375);
  };

  if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    };
  }

  return {
    init: _init
  };

}();

if(document.getElementById('leadHeader')){
  HomepageCarousel.init();
}


// WEBPACK FOOTER //
// ./resources/assets/js/partials/HomepageCarousel.js